// extracted by mini-css-extract-plugin
export default {"image-upload-editor-wrapper":"image-upload-editor-wrapper--nkO7_2pV","imageUploadEditorWrapper":"image-upload-editor-wrapper--nkO7_2pV"};